<template>
  <div>
    <div>
      <div class="headline primary--text">
        Welcome Back!
      </div>
      <div class="caption grey--text">
        Login to access Haulier Shipping Calculation System
      </div>
    </div>

    <div class="my-5">
      <validation-observer
        ref="loginForm"
        @keyup.13="validateAndLogin"
      >
        <validation-provider
          v-slot="{ errors }"
          name="Email"
          rules="required|email"
        >
          <v-text-field
            v-model="email"
            label="Email"
            :error="!!errors.length"
            :error-messages="errors"
            prepend-inner-icon="mdi-email-outline"
          />
        </validation-provider>

        <validation-provider
          v-slot="{ errors }"
          name="Password"
          rules="required"
        >
          <v-text-field
            v-model="password"
            label="Password"
            prepend-inner-icon="mdi-lock-outline"
            :type="showPassword ? 'text' : 'password'"
            :error="!!errors.length"
            :error-messages="errors"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
        </validation-provider>

        <v-checkbox
          :input-value="true"
          label="Remember Me"
        />
      </validation-observer>
    </div>

    <div class="d-flex justify-space-between">
      <v-btn
        :loading="isLoggingIn"
        depressed
        color="secondary"
        @click="validateAndLogin"
      >
        Login
      </v-btn>
      <v-btn
        text
        color="grey"
        @click="$router.push('/accounts/forgot-password')"
      >
        Forgot Password ?
      </v-btn>
    </div>

    <div class="d-flex align-center my-12">
      <v-divider />
      <span class="mx-4 grey--text">OR</span>
      <v-divider />
    </div>

    <v-btn
      outlined
      color="grey"
    >
      <v-img
        width="20"
        height="20"
        class="mr-2"
        src="@/assets/images/accounts/google-logo.png"
      />Login with Google
    </v-btn>

    <v-snackbar
      v-model="snackbar.isOpen"
      right
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { auth } from '@/firebase';

export default {
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      isLoggingIn: false,
      snackbar: {
        text: '',
        color: 'red',
        isOpen: false,
      },
    };
  },
  methods: {
    async validateAndLogin() {
      const isFormValid = await this.$refs.loginForm.validate();
      if (!isFormValid) {
        return;
      }

      this.login();
    },
    login() {
      this.isLoggingIn = true;

      auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.$router.push('/');
        })
        .catch((error) => {
          this.snackbar = {
            color: 'red',
            isOpen: true,
            text: error.message,
          };
        })
        .finally(() => {
          this.isLoggingIn = false;
        });
    },
  },
};
</script>
